import {Breadcrumbs, styled} from '@mui/material';

const StyledBreadcrumbs = styled(Breadcrumbs)`
	padding-inline: 60px;
	padding-bottom: 12px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding-inline: 78px;
		padding-bottom: 20px;
	}

	& .MuiBreadcrumbs-separator {
		color: white;
	}
`;

export {StyledBreadcrumbs};
